export default __webpack_public_path__ + "static/b3-121bfe65ff4985fb0bf50835f3cda3a3.png";